import { useUserPermission } from 'ccs-ui-components';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import UserIcon from '../../components/assets/user-icon.svg';
import MainHeaderImage from '../../components/icons/MainHeaderImage';
import classes from './MainHeader.module.scss';

const MainHeader = () => {
  const { t: translate } = useTranslation();
  const { permissionObject } = useUserPermission();

  return (
    <div className={classes.container}>
      <Row className={classes['container-body']}>
        <Col xs={12} sm={12} md={3} lg={1} className={classes['container-img-icon']}>
          <img src={UserIcon} alt="user icon" />
        </Col>

        <Col xs={12} sm={12} md={9} lg={7} className={classes['container-text']}>
          <div className={classes['heading-title']}>
            <span data-testid="welcome-header">{translate('main_header_component.title_dashboard')}&nbsp;
              {permissionObject?.user.name.split(' ')[0]}!
            </span>
          </div>
        </Col>

        <Col xs={12} sm={12} md={12} lg={4} className={classes['container-img']}>
          <div data-testid="main-header-image-wrapper">
            <MainHeaderImage />
          </div>
        </Col>
      </Row>
    </div>
  );
};
export default MainHeader;
